import React from 'react';
import { Provider } from 'react-redux';
import { ReduxContext } from './ReduxContext';

const ReduxProvider = ({ store, children }) => (
  <Provider context={ReduxContext} store={store}>
    {children}
  </Provider>
);
export { ReduxProvider };
